import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Grid, Typography } from "@mui/material";

const INITIAL_ERROR = {
  otp: "",
};

const OtpModal = ({
  open,
  onClose,
  mobileNo,
  onSendOtp,
  onSubmitOtp,
  resendTimerSeconds = 300,
  modalTitle = "Verify Mobile Number",
  submitButtonLabel = "Verify & Submit",
}) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(INITIAL_ERROR);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const countdownRef = useRef(resendTimerSeconds);
  const startTime = useRef(null);
  const spanRef = useRef(null);

  const handleSendOtp = async () => {
    const success = await onSendOtp?.();
    if (success !== false) {
      setIsOtpSent(true);
      startTimer();
    }
  };

  const handleOtpChange = (event) => {
    setError(INITIAL_ERROR);
    const value = event.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  const handleSubmit = () => {
    let isError = false;
    let errorObj = { ...INITIAL_ERROR };

    if (!otp) {
      isError = true;
      errorObj.otp = "OTP is required.";
    } else if (otp.length !== 6) {
      isError = true;
      errorObj.otp = "Please enter a valid 6-digit OTP.";
    }

    if (isError) {
      setError(errorObj);
      return;
    }

    onSubmitOtp?.(otp);
    // setOtp("");
    setError(INITIAL_ERROR);
  };

  const startTimer = () => {
    countdownRef.current = resendTimerSeconds;
    startTime.current = new Date();
    if (spanRef.current) {
      spanRef.current.textContent = resendTimerSeconds;
    }
    setShowTimer(true);
  };

  useEffect(() => {
    if (open) {
      handleSendOtp();
    }
  }, [open]);

  useEffect(() => {
    let intervalId;
    if (showTimer) {
      intervalId = setInterval(() => {
        const currentTime = new Date();
        let timeDiff = Math.floor((currentTime - startTime.current) / 1000);
        countdownRef.current = resendTimerSeconds - timeDiff;

        if (countdownRef.current <= 0) {
          clearInterval(intervalId);
          setShowTimer(false);
        }

        if (spanRef.current) {
          spanRef.current.textContent = `${Math.floor(countdownRef.current / 60)}:${
            countdownRef.current % 60 < 10 ? `0${countdownRef.current % 60}` : countdownRef.current % 60
          }`;
        }
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [showTimer]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{modalTitle}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} marginTop={1}>
          <Grid item xs={12}>
            <TextField
              label="Mobile Number"
              value={mobileNo}
              type="tel"
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendOtp}
              disabled={!mobileNo || isOtpSent}
              fullWidth
            >
              Send OTP
            </Button>
          </Grid>
          {isOtpSent && (
            <>
              <Grid item xs={12}>
                <TextField
                  label="Enter OTP"
                  value={otp}
                  onChange={handleOtpChange}
                  inputProps={{ maxLength: 6 }}
                  fullWidth
                  error={!!error.otp}
                  helperText={error.otp}
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                {showTimer ? (
                  <Typography variant="body2">
                    Please wait <span ref={spanRef}>{resendTimerSeconds}</span> to resend OTP
                  </Typography>
                ) : (
                  <Button variant="outlined" onClick={handleSendOtp}>
                    Resend OTP
                  </Button>
                )}
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!isOtpSent}
        >
          {submitButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OtpModal;
